import { Box, List, Text } from '@dixa/lib-shared-habla';
import { Message } from 'lib-shared-legacy-types';

import { Message as MessageComponent } from '../message';

import { TextMessageProps } from './TextMessage';

type MessengerMenuMessage = Message & { messenger_choices: string };
type MessengerMenuOption = { text: string; id: string };

type MessengerChoicesOldFormat = MessengerMenuOption[];
type MessengerChoicesNewFormat = {
  choices: MessengerMenuOption[];
  isHorizontal: boolean;
};
type MessengerChoices = MessengerChoicesOldFormat | MessengerChoicesNewFormat;

export type MessageWidgetMenuProps = TextMessageProps & {
  message: MessengerMenuMessage;
};

export function MessageWidgetMenu({
  message,
}: MessageWidgetMenuProps): JSX.Element {
  const { title, options } = parseMessengerMenuContent(message);

  return (
    <MessageComponent
      author={message.author}
      content={
        <Box padding="100 0">
          <Text.Paragraph variant="2">{title}</Text.Paragraph>
          <List>
            {options?.map(({ id, text }) => (
              <List.Item key={id} title={text} withHoverEffect={false} />
            ))}
          </List>
        </Box>
      }
    />
  );
}

function parseMessengerMenuContent(message: MessengerMenuMessage) {
  const fallbackResult = { title: 'Choices:', options: [] };

  try {
    const choices: MessengerChoices = JSON.parse(message.messenger_choices);

    return {
      title: message.messenger_title || message.text || 'Choices:',
      options: Array.isArray(choices) ? choices : choices.choices,
    };
  } catch (error) {
    return fallbackResult;
  }
}

export function isMessengerMenuMessage(
  message: Message,
): message is MessengerMenuMessage {
  return Boolean(message.messenger_choices);
}
